interface SituationalAwarenessBannerProps {
  /** Banner copy; defaults to the not-performed message */
  message?: string;
}

export function SituationalAwarenessBanner({
  message = 'Situational Awareness Validation Has Not Been Performed',
}: SituationalAwarenessBannerProps = {}) {
  return (
    <div className="bg-chariot-background-secondary mb-4 rounded-lg p-4 text-center">
      <p className="text-chariot-text-secondary text-sm font-medium">
        {message}
      </p>
    </div>
  );
}
